/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterSubmissionStatsResponseDto
 */
export interface FilterSubmissionStatsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof FilterSubmissionStatsResponseDto
     */
    total: number;
}

/**
 * Check if a given object implements the FilterSubmissionStatsResponseDto interface.
 */
export function instanceOfFilterSubmissionStatsResponseDto(value: object): value is FilterSubmissionStatsResponseDto {
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function FilterSubmissionStatsResponseDtoFromJSON(json: any): FilterSubmissionStatsResponseDto {
    return FilterSubmissionStatsResponseDtoFromJSONTyped(json, false);
}

export function FilterSubmissionStatsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterSubmissionStatsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
    };
}

export function FilterSubmissionStatsResponseDtoToJSON(json: any): FilterSubmissionStatsResponseDto {
    return FilterSubmissionStatsResponseDtoToJSONTyped(json, false);
}

export function FilterSubmissionStatsResponseDtoToJSONTyped(value?: FilterSubmissionStatsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
    };
}

